// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"33b2b77f21490c6cfefb","3180":"19f37ee1e9ee69f14d61","9635":"84a3c29283135b4e54d4"}[chunkId] + ".css";
};